<template>
    <div class="cepingBox">
        <NavMenu/>
        <div class="evaluateHomePageWarp">
            <!-- <div class="headTitle">
                <div class="title">人力资源服务机构能力指数评测</div>
                <div class="return" @click="cancelForm">返回</div>
            </div> -->
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" label-position='top' :validate-on-rule-change="false">
                <div class="dialogformCenter">
                    <el-tabs v-model="activeName">
                        <el-tab-pane label="从业人员数量情况" name="从业人员数量情况">
                            <!-- <div class="bigTitle">一、从业人员数量情况</div> -->
                            <el-form-item label="1.从业人员总数：" prop="1">
                                <el-input v-model="ruleForm[1]" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="2.是否仅开展高级人才寻访、人才测评或人力资源管理咨询服务：" prop="2">
                                <el-radio-group v-model="ruleForm[2]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="3.本科学历及以上学历（人数）：" prop="3">
                                <el-input v-model="ruleForm[3]" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="4.人均年培训课时数：" prop="4">
                                <el-input v-model="ruleForm[4]" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="5.中层以上(含中层)负责人具有中级及以上专业技术职务任职资格或职（执）业资格比例（%）：" prop="5">
                                <el-input v-model="ruleForm[5]" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="6.是否对客户提出的问题，耐心解释：" prop="6">
                                <el-radio-group v-model="ruleForm[6]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="7.客户满意度（%）：" prop="7">
                                <el-input v-model="ruleForm[7]" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="8.是否在承诺的时间内完成服务：" prop="8">
                                <el-radio-group v-model="ruleForm[8]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-tab-pane>
                        <el-tab-pane label="服务项目" name="服务项目">
                            <!-- <div class="bigTitle">二、服务项目</div> -->
                            <el-form-item label="9.选择服务项目（可多选）：" prop="9">
                                <el-select v-model="ruleForm[9]" multiple placeholder="请选择" style="width:46%">
                                    <el-option v-for="item in allServiceData" :key="item.indicatorId" :label="item.indicatorName" :value="item.indicatorId">
                                    </el-option>
                                    <el-option label="其他服务" value="其他服务"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="10.主营业务测评(可选项不能超过5个，必选一个)：" prop="10" class="label10" :rules="formRules[10]">
                                <div class="yetwarp">
                                    已保存的测评服务项目：
                                    <div v-for="(item,index) in saveValue" :key="index" class="yetservicebox">
                                        <span @click="clickServiceFn(item.indicatorName)">{{item.indicatorName}}</span>
                                        <el-popconfirm title="是否确定删除该项测评服务项目?" confirm-button-text='确定' cancel-button-text='取消' @confirm="deleteFn(item.indicatorId)">
                                            <i v-if='!result' class="el-icon-circle-close iconbox" slot="reference" />
                                        </el-popconfirm>
                                    </div>
                                </div>
                                <div class="finishwarp">
                                    已完成的测评服务项目：
                                    <div v-for="(item,index) in selectValue" :key="index" class="service-box">
                                        <span @click="clickServiceFn(item.indicatorName)">{{item.indicatorName}}</span>
                                        <el-popconfirm title="是否确定删除该项测评服务项目?" confirm-button-text='确定' cancel-button-text='取消' @confirm="deleteFn(item.indicatorId)">
                                            <i v-if='!result' class="el-icon-circle-close iconbox" slot="reference" />
                                        </el-popconfirm>
                                    </div>
                                </div>
                                <!-- :disabled="selectValue.length>=5?true:false" -->
                                <el-select v-model="ruleForm[10]" placeholder="请选择" @change="changeserviceFn" :disabled="selectValue.length>=5?true:false">
                                    <el-option v-for="item in ServiceData" :key="item.indicatorId" :label="item.indicatorName" :value="item.indicatorName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <!-- 现场招聘会服务 -->
                            <div class="componentsBox" v-if="componentsFlag">
                                <mainbusinessPage1 :result='result' :saveId='saveId' v-if="showVisible1" @getyetServiceFn='getyetServiceFn' />
                                <mainbusinessPage2 :result='result' :saveId='saveId' v-if="showVisible2" @getyetServiceFn='getyetServiceFn' />
                                <mainbusinessPage3 :result='result' :saveId='saveId' v-if="showVisible3" @getyetServiceFn='getyetServiceFn' />
                                <mainbusinessPage4 :result='result' :saveId='saveId' v-if="showVisible4" @getyetServiceFn='getyetServiceFn' />
                                <mainbusinessPage5 :result='result' :saveId='saveId' v-if="showVisible5" @getyetServiceFn='getyetServiceFn' />
                                <mainbusinessPage6 :result='result' :saveId='saveId' v-if="showVisible6" @getyetServiceFn='getyetServiceFn' />
                                <mainbusinessPage7 :result='result' :saveId='saveId' v-if="showVisible7" @getyetServiceFn='getyetServiceFn' />
                                <mainbusinessPage8 :result='result' :saveId='saveId' v-if="showVisible8" @getyetServiceFn='getyetServiceFn' />
                                <mainbusinessPage9 :result='result' :saveId='saveId' v-if="showVisible9" @getyetServiceFn='getyetServiceFn' />
                                <mainbusinessPage10 :result='result' :saveId='saveId' v-if="showVisible10" @getyetServiceFn='getyetServiceFn' />
                            </div>

                            <el-form-item label=" 11.上一年度主营业务年收入__万元：" prop="11">
                                <el-input v-model="ruleForm[11]" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label=" 12.上一年度总业务年收入__万元：" prop="12">
                                <el-input v-model="ruleForm[12]" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label=" 13.注册资本__万元：" prop="13">
                                <el-input v-model="ruleForm[13]" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label=" 14.净资产__万元：" prop="14">
                                <el-input v-model="ruleForm[14]" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-tab-pane>
                        <el-tab-pane label="设施设备" name="设施设备">
                            <!-- <div class="bigTitle">三、设施设备</div> -->
                            <el-form-item label=" 15.服务机构场所建筑面积（平米）：" prop="15">
                                <el-input v-model="ruleForm[15]" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="16.服务机构是否设有采暖和制冷设备：" prop="16">
                                <el-radio-group v-model="ruleForm[16]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="17.服务机构是否设有公共卫生间：" prop="17">
                                <el-radio-group v-model="ruleForm[17]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="18.服务机构是否设有客户洽谈场所：" prop="18">
                                <el-radio-group v-model="ruleForm[18]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="19.服务机构是否设有客户服务厅：" prop="19">
                                <el-radio-group v-model="ruleForm[19]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="20.服务机构是否有发布供求信息的电子显示屏：" prop="20">
                                <el-radio-group v-model="ruleForm[20]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="21.服务机构是否设有客户洽谈室：" prop="21">
                                <el-radio-group v-model="ruleForm[21]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="22.服务机构是否设有服务网站：" prop="22">
                                <el-radio-group v-model="ruleForm[22]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="23.服务机构是否设有信息触摸查询系统（自助一体机）：" prop="23">
                                <el-radio-group v-model="ruleForm[23]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="24.服务机构是否设有智能排队管理系统和等候休息区：" prop="24">
                                <el-radio-group v-model="ruleForm[24]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="25.服务机构的客户服务厅建筑面积（平方米）：" prop="25">
                                <el-input v-model="ruleForm[25]" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="26.服务机构的电话机、计算机人均不少于1台：" prop="26">
                                <el-radio-group v-model="ruleForm[26]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="27.服务机构的复印机、传真机各不少于1台：" prop="27">
                                <el-radio-group v-model="ruleForm[27]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="28.服务机构的有为客户使用的电话、打印、复印、传真等设备，性能良好：" prop="28">
                                <el-radio-group v-model="ruleForm[28]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="29.服务机构的客户服务电话接听通畅：" prop="29">
                                <el-radio-group v-model="ruleForm[29]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="30.服务机构的配有笔记本电脑、投影仪、录音、照相等设备：" prop="30">
                                <el-radio-group v-model="ruleForm[30]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label=" 31.服务机构的配备软件系统服务器不少于1台：" prop="31">
                                <el-radio-group v-model="ruleForm[31]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="  32.服务机构设有内部局域网络管理系统及网络办公系统：" prop="32">
                                <el-radio-group v-model="ruleForm[32]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label=" 33.服务机构的消防、安全设施设备是否完备、有效，标识明显、清晰：" prop="33">
                                <el-radio-group v-model="ruleForm[33]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="  34.服务机构重要部位是否备有灭火设备：" prop="34">
                                <el-radio-group v-model="ruleForm[34]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="35.服务机构紧急出口通道是否畅通，标识明显、清晰：" prop="35">
                                <el-radio-group v-model="ruleForm[35]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="36.服务机构的服务场所是否设有安全、消防报警及自动喷淋灭火系统：" prop="36">
                                <el-radio-group v-model="ruleForm[36]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label=" 37.服务机构的重要部位是否设有监控设备：" prop="37">
                                <el-radio-group v-model="ruleForm[37]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="38.服务机构是否配有消防广播系统：" prop="38">
                                <el-radio-group v-model="ruleForm[38]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-tab-pane>
                        <el-tab-pane label="服务环境" name="服务环境">
                            <!-- <div class="bigTitle">四、服务环境</div> -->
                            <el-form-item label="39.服务机构所在地交通是否便利：" prop="39">
                                <el-radio-group v-model="ruleForm[39]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="40.服务机构是否位于城区内主要街道：" prop="40">
                                <el-radio-group v-model="ruleForm[40]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="41.有多少条公共交通线路可到达服务机构：" prop="41">
                                <el-input v-model="ruleForm[41]" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="42.服务场所标识（公共图形）摆放位置是否合理：" prop="42">
                                <el-radio-group v-model="ruleForm[42]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="43.服务场所各种标识（公共图形）是否符合GB2894、GB/T10001.9、GB/T10001.1等规定：" prop="43">
                                <el-radio-group v-model="ruleForm[43]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="44.服务场所标识（公共图形）设置是否协调统一：" prop="44">
                                <el-radio-group v-model="ruleForm[44]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="45.服务场所标识（公共图形）是否醒目、易识别：" prop="45">
                                <el-radio-group v-model="ruleForm[45]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="46.服务场所标识（公共图形）信息系统是否完备：" prop="46">
                                <el-radio-group v-model="ruleForm[46]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="47.服务机构是否同时具备人力资源服务许可证、营业执照和法人证书、收费许可证、收费项目表或税务登记证：" prop="47">
                                <el-radio-group v-model="ruleForm[47]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="48.服务机构是否对服务机构简介进行公示：" prop="48">
                                <el-radio-group v-model="ruleForm[48]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="49.服务机构是否对服务项目介绍进行公示：" prop="49">
                                <el-radio-group v-model="ruleForm[49]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="50.服务机构的服务场所是否设有引导图：" prop="50">
                                <el-radio-group v-model="ruleForm[50]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="51.服务机构是否设有展示服务机构形象宣传栏：" prop="51">
                                <el-radio-group v-model="ruleForm[51]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="52.服务场所布局是否合理、整洁卫生：" prop="52">
                                <el-radio-group v-model="ruleForm[52]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="53.服务场所通风、采光、照明是否良好，远离噪音等干扰：" prop="53">
                                <el-radio-group v-model="ruleForm[53]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="54.服务场所是否方便客户正常活动：" prop="54">
                                <el-radio-group v-model="ruleForm[54]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="55.服务场所是否设有无障碍设施：" prop="55">
                                <el-radio-group v-model="ruleForm[55]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="56.服务场所设施设备是否确保安全：" prop="56">
                                <el-radio-group v-model="ruleForm[56]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-tab-pane>
                        <el-tab-pane label="规章制度" name="规章制度">
                            <!-- <div class="bigTitle">五、规章制度</div> -->
                            <el-form-item label="57.是否有员工手册：" prop="57">
                                <el-radio-group v-model="ruleForm[57]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="58.员工对员工手册内容的知晓率（%）：" prop="58">
                                <el-input v-model="ruleForm[58]" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label=" 59.是否有岗位说明书：" prop="59">
                                <el-radio-group v-model="ruleForm[59]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="60.员工对岗位说明书内容的知晓率（%）：" prop="60">
                                <el-input v-model="ruleForm[60]" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label=" 61.是否有管理制度" prop="61">
                                <el-radio-group v-model="ruleForm[61]" placeholder="请选择">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="62.员工对管理制度内容的知晓率（%）：" prop="62">
                                <el-input v-model="ruleForm[62]" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="63.几年内无违法违规行为（年）：" prop="63">
                                <el-input v-model="ruleForm[63]" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="64.几年内无泄密事件发生（年）：" prop="64">
                                <el-input v-model="ruleForm[64]" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div class="dialogformBottomBtnBox" v-if='!result'>
                    <el-button @click="draftForm" class="submitdraftBtn">存为草稿</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')" class="submitBtn" :loading="isloading">提交</el-button>
                    <el-button @click="cancelForm" class="cancelBtn">返回</el-button>
                </div>
                <div class="dialogformBottomBtnBox" v-else>
                    <el-button @click="cancelForm" class="cancelBtn">返回</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import { httpService } from "@/service/httpService";
import mainbusinessPage1 from './mainbusinessPage1';
import mainbusinessPage2 from './mainbusinessPage2';
import mainbusinessPage3 from './mainbusinessPage3';
import mainbusinessPage4 from './mainbusinessPage4';
import mainbusinessPage5 from './mainbusinessPage5';
import mainbusinessPage6 from './mainbusinessPage6';
import mainbusinessPage7 from './mainbusinessPage7';
import mainbusinessPage8 from './mainbusinessPage8';
import mainbusinessPage9 from './mainbusinessPage9';
import mainbusinessPage10 from './mainbusinessPage10';
// import { nextTick } from 'q';
export default {
    components: {
        NavMenu,
        mainbusinessPage1,
        mainbusinessPage2,
        mainbusinessPage3,
        mainbusinessPage4,
        mainbusinessPage5,
        mainbusinessPage6,
        mainbusinessPage7,
        mainbusinessPage8,
        mainbusinessPage9,
        mainbusinessPage10,
    },
    data() {
        return {
            isloading: false,
            result: '',
            ServiceData: [],
            allServiceData: [],
            selectService: [],
            selectValue: [],
            saveValue: [],
            showVisible1: false,
            showVisible2: false,
            showVisible3: false,
            showVisible4: false,
            showVisible5: false,
            showVisible6: false,
            showVisible7: false,
            showVisible8: false,
            showVisible9: false,
            showVisible10: false,
            componentsFlag: false,
            saveId: null,
            ruleForm: {
                1: '',
                2: '',
                3: '',
                4: '',
                5: '',
                6: '',
                7: '',
                8: '',
                9: [],
                10: [],
                11: '',
                12: '',
                13: '',
                14: '',
                15: '',
                16: '',
                17: '',
                18: '',
                19: '',
                20: '',
                21: '',
                22: '',
                23: '',
                24: '',
                25: '',
                26: '',
                27: '',
                28: '',
                29: '',
                30: '',
                31: '',
                32: '',
                33: '',
                34: '',
                35: '',
                36: '',
                37: '',
                38: '',
                39: '',
                40: '',
                41: '',
                42: '',
                43: '',
                44: '',
                45: '',
                46: '',
                47: '',
                48: '',
                49: '',
                50: '',
                51: '',
                52: '',
                53: '',
                54: '',
                55: '',
                56: '',
                57: '',
                58: '',
                59: '',
                60: '',
                61: '',
                62: '',
                63: '',
                64: '',
            },
            rules: {
                // 正整数
                1: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                // 单选
                2: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                3: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                4: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: "^[1-9]\\d{0,20}(\\.\\d{1,2})?$|^0(\\.\\d{1,2})?$", message: '请输入大于等于0的正整数，最多保留2位小数', trigger: 'blur' },
                ],
                // 小数
                5: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                6: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                7: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                8: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                // 多选
                9: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                10: [
                    // { required: true, message: '请选择', trigger: 'change' }
                ],
                11: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                12: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                13: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                14: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                15: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                16: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                17: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                18: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                19: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                20: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                21: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                22: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                23: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                24: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                25: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                26: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                27: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                28: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                29: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                30: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                31: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                32: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                33: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                34: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                35: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                36: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                37: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                38: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                39: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                40: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                41: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                42: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                43: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                44: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                45: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                46: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                47: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                48: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                49: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                50: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                51: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                52: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                53: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                54: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                55: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                56: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                57: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                58: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                59: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                60: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                61: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                62: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                63: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                64: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                // select: [
                //     { required: true, message: '请选择活动资源', trigger: 'change' }
                // ],

            },
            formRules: {},
            activeName: '从业人员数量情况',
            openService: '',//打开的子组件
        }
    },
    created() {
        // 路由传递分数过来
        this.result = this.$route.query.result || this.$route.params.result;
        // 服务项目
        this.getserviceFn()
        this.selectAllServiceFn()
        // 已选择的服务
        this.selectServiceFn()
        // 回显表单
        this.yetData()
        // 已保存的服务
        this.getSavedTableBFn()
    },
    methods: {
        // 能够选择的服务
        async getserviceFn() {
            let data = await httpService.getIndicatorServiceFn();
            if (data.code == 200) {
                this.ServiceData = data.result
            }
        },
        // 全部服务项目
        async selectAllServiceFn() {
            let data = await httpService.getIndicatorServiceAll();
            if (data.code == 200) {
                this.allServiceData = data.result
            }
        },
        // 已完成的服务
        async selectServiceFn() {
            let data = await httpService.getchoiceIndicatorService();
            if (data.code == 200) {
                this.selectValue = data.result
            }
        },
        // 保存的服务
        async getSavedTableBFn() {
            let data = await httpService.getSavedTableB();
            if (data.code == 200) {
                this.saveValue = data.result
            }
        },
        // 删除已选择的服务
        async deleteFn(id) {
            let data = await httpService.deleteChoiceIndicatorService(id);
            if (data.code == 200) {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                // 保存
                this.getSavedTableBFn()
                // 完成
                this.selectServiceFn()
                // 可选
                this.getserviceFn()
            } else {
                this.$message.error(res.message);
            }
        },
        // 提交
        async submitForm(formName) {
            // 保存不通过validate检验
            if (this.selectValue.length == 0) {
                // this.formRules = {
                //     10: [
                //         { required: true, message: '请选择', trigger: 'change' }
                //     ]
                // }
                this.$message.error('10题主营业务请必选一项填写')
                return
            } else {
                this.formRules = {}
            }
            console.log(this.$refs[formName]);
            this.$refs[formName].validate((valid, obj) => {
                let newForm = JSON.parse(JSON.stringify(this.ruleForm))
                if (valid) {
                    this.isloading = true
                    let NewDataList = []
                    if (newForm[9].length != 0) {
                        newForm[9] = newForm[9].join(',')
                    } else {
                        newForm[9] = ''
                    }
                    let selectserviceValue = []
                    if (this.selectValue.length != 0) {
                        this.selectValue.map(item => {
                            return selectserviceValue.push(item.indicatorId)
                        })
                        newForm[10] = selectserviceValue.join(',')
                    } else {
                        newForm[10] = ''
                    }
                    for (const key in newForm) {
                        let obj = {}
                        obj.serialNumber = key;
                        obj.evaluateValue = newForm[key]
                        NewDataList.push(obj)
                    }
                    httpService.addScoreHomeFn(NewDataList).then(res => {
                        // if (res) {
                        this.isloading = false
                        if (res.code == 200) {
                            this.$message({
                                message: '提交成功',
                                type: 'success'
                            });
                            // 是否返回测评首页
                            this.$router.push('/assessment-institutions')
                        } else {
                            this.$message.error(res.message);
                        }
                        // }
                    })
                } else {
                    let arr = []
                    for (const key in obj) {
                        if (Object.hasOwnProperty.call(obj, key)) {
                            let ele = key + '题、'
                            arr.push(ele)
                        }
                    }
                    let str = arr.join('')
                    this.$message.error(`${str}未填写，请检查！`);
                    return false;
                }
            });
        },
        // 存为草稿
        draftForm() {
            let NewDataList = []
            this.ruleForm[9] = this.ruleForm[9].join(',')
            let selectserviceValue = []
            if (this.selectValue.length != 0) {
                this.selectValue.map(item => {
                    return selectserviceValue.push(item.indicatorId)
                })
            }
            this.ruleForm[10] = selectserviceValue.join(',')
            for (const key in this.ruleForm) {
                let obj = {}
                obj.serialNumber = key;
                obj.evaluateValue = this.ruleForm[key]
                NewDataList.push(obj)
            }
            httpService.addDraftFn(NewDataList).then(res => {
                if (res.code == 200) {
                    this.$message({
                        message: '草稿保存成功',
                        type: 'success'
                    });
                    // 数据回显
                    this.yetData()
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        // 回填表单数据
        yetData() {
            httpService.backfillHomeFormFn().then(res => {
                if (res.code == 200) {
                    if (res.result.length != 0) {
                        let obj = {}
                        for (const key in res.result) {
                            obj[res.result[key].serialNumber] = res.result[key].evaluateValue
                        }
                        this.ruleForm = obj
                        if (res.result[8].evaluateValue) {
                            // 9题多选值回填
                            this.ruleForm[9] = res.result[8].evaluateValue.split(',')
                        } else {
                            this.ruleForm[9] = []
                        }
                        // 保存时重新获取已选的服务，回显不用展示
                        this.ruleForm[10] = []
                        this.$nextTick(() => {
                            this.$refs["ruleForm"].clearValidate()
                        })
                    }
                }
            })
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        cancelForm() {
            this.$router.push('/assessment-institutions')
        },
        // 10题选择服务
        changeserviceFn(value) {
            this.showVisible1 = false
            this.showVisible2 = false
            this.showVisible3 = false
            this.showVisible4 = false
            this.showVisible5 = false
            this.showVisible6 = false
            this.showVisible7 = false
            this.showVisible8 = false
            this.showVisible9 = false
            this.showVisible10 = false
            this.allServiceData.forEach(e => {
                if (e.indicatorName == value) {
                    this.saveId = e.indicatorId
                }
            });
            this.openService = value
            if (this.openService == '现场招聘会服务') {
                this.showVisible1 = true
                this.componentsFlag = true
                this.stopScroll()
            }
            else if (this.openService == '人力资源网站服务') {
                this.showVisible2 = true
                this.componentsFlag = true
                this.stopScroll()
            }
            else if (this.openService == '高级人才寻访服务') {
                this.showVisible3 = true
                this.componentsFlag = true
                this.stopScroll()
            }
            else if (this.openService == '职业指导服务') {
                this.showVisible4 = true
                this.componentsFlag = true
                this.stopScroll()
            }
            else if (this.openService == '人才测评服务业务') {
                this.showVisible5 = true
                this.componentsFlag = true
                this.stopScroll()
            }
            else if (this.openService == '人力资源培训服务') {
                this.showVisible6 = true
                this.componentsFlag = true
                this.stopScroll()
            }
            else if (this.openService == '人力资源管理咨询服务') {
                this.showVisible7 = true
                this.componentsFlag = true
                this.stopScroll()
            }
            else if (this.openService == '流动人员人事档案管理服务') {
                this.showVisible8 = true
                this.componentsFlag = true
                this.stopScroll()
            }
            else if (this.openService == '人力资源外包服务') {
                this.showVisible9 = true
                this.componentsFlag = true
                this.stopScroll()
            }
            else if (this.openService == '职业介绍服务') {
                this.showVisible10 = true
                this.componentsFlag = true
                this.stopScroll()
            }
        },
        // 查看已选择的服务
        clickServiceFn(value) {
            this.changeserviceFn(value)
        },
        // 子组件提交获取已选择的服务
        getyetServiceFn() {
            this.selectServiceFn()
            this.showVisible1 = false
            this.showVisible2 = false
            this.showVisible3 = false
            this.showVisible4 = false
            this.showVisible5 = false
            this.showVisible6 = false
            this.showVisible7 = false
            this.showVisible8 = false
            this.showVisible9 = false
            this.showVisible10 = false
            this.componentsFlag = false
            this.saveId = null
            this.canScroll()
            this.ruleForm[10] = []
            this.getserviceFn()
            // 已保存的服务
            this.getSavedTableBFn()
        }
    },
}
</script>
<style lang="less" scoped>
.cepingBox {
	width: 100%;
	margin: 0 auto;
}
.evaluateHomePageWarp {
	width: 1400px;
	margin: 0 auto;
	padding: 0 10px 0 50px;
	box-sizing: border-box;
	/deep/.el-input__inner {
		width: 612px;
		// max-width: 90%;
	}
	.headTitle {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		padding-bottom: 10px;
		border-bottom: 1px solid #dddddd;
		margin: 50px 0 25px 0;
		.title {
			font-size: 22px;
			font-weight: bolder;
			color: #333;
		}
		.return {
			font-size: 16px;
			cursor: pointer;
			color: #448df7;
		}
	}
	.componentsBox {
		width: 1200px;
		height: 700px;
		// overflow-y: auto;
		border: 1px solid #d2d2d2;
		box-sizing: border-box;
        margin-left: 80px;
        margin-bottom: 12px;
	}
	.label10 {
		/deep/.el-form-item__label {
			padding-left: 12px;
		}
	}
	.finishwarp {
		display: flex;
		flex-direction: row;
		font-size: 16px;
		position: relative;
		margin: 0px 0 10px 0;
		.service-box {
			cursor: pointer;
			color: #349cff;
			margin-right: 12px;
			.iconbox {
				font-size: 18px;
				color: #a6a9b7;
				margin-left: 4px;
			}
		}
	}
	.yetwarp {
		display: flex;
		flex-direction: row;
		font-size: 16px;
		position: relative;
		// width: 100px;
		&::before {
			position: absolute;
			top: -40px;
			left: 0px;
			// margin-right: 4px;
			color: #ff4d4f;
			font-size: 16px;
			font-family: SimSun, sans-serif;
			line-height: 1;
			content: '*';
		}
		.yetservicebox {
			cursor: pointer;
			color: #52ca9c;
			margin-right: 12px;
			.iconbox {
				font-size: 18px;
				color: #a6a9b7;
				margin-left: 4px;
			}
		}
	}
	// 测评的公共样式
	.dialogformCenter {
		width: 100%;
		height: 720px;
		overflow-y: scroll;
		margin-bottom: 10px;
        margin-top: 12px;
        /deep/.el-tabs__item{
            font-size: 16px;
            font-weight: bold;
        }
	}
	.bigTitle {
		font-size: 18px;
		font-weight: bold;
		color: #333333;
	}
	.dialogformCenter::-webkit-scrollbar {
		// width: 8px;
		width: 0px;
		/*height: 4px;*/
	}
	.dialogformCenter::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: rgba(0, 0, 0, 0.2);
	}
	.dialogformCenter::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}
	.dialogformBottomBtnBox {
		border-top: 1px solid #ccc;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		padding: 15px 0;
		.submitBtn {
			width: 152px;
			height: 40px;
			background: #349cff;
			margin: 0 20px;
		}
		.cancelBtn {
			width: 152px;
			height: 40px;
			border: 1px solid #a6a9b7;
			border-radius: 5px;
			margin: 0 20px;
		}
		.submitdraftBtn {
			width: 152px;
			height: 40px;
			background: #52ca9c;
			margin: 0 20px;
			color: #fff;
		}
	}

	// /deep/.el-select-dropdown{
	//     position: absolute;
	//     left: 50px;
	// }
}
</style>


